import { Station } from '@app/core/types/stations';
import { auditScheduleAuditSchedulesBulkCreate } from '@mi-front/api-v2';
import { apiClient } from '@app/api';
import { ValidateAndUploadView } from '../../../../../../../../components/validate-upload-view/ValidateAndUploadView';
import { CreateSchedulesPreview } from '../common/CreateSchedulesPreview';

/**
 * PLK schedule upload: parse stays on legacy logger-api; create uses api-v2 bulk.
 */
export function AudioSchedulesPlkUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadView
      allowedExtensions={['.plk']}
      validateFn={(file: File) =>
        apiClient.audit.plkParse({
          stationId: station.id,
          file: file!,
        })
      }
      importFn={(_file, data) =>
        auditScheduleAuditSchedulesBulkCreate(
          data.map((item) => ({
            customId: item.customId,
            datetime: item.datetime,
            type: 'SPOT',
            tolerance: item.tolerance ?? undefined,
            toleranceBefore: item.toleranceBefore ?? undefined,
            advertiser: item.advertiser ?? undefined,
            campaign: item.campaign ?? undefined,
            version: item.version ?? undefined,
            custom: item.custom ?? undefined,
          })),
          { station: station.id },
        )
      }
      renderPreview={(data) => <CreateSchedulesPreview data={data} />}
    />
  );
}
